'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _StreamData = require('./StreamData');

var _StreamData2 = _interopRequireDefault(_StreamData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var messageDict = {
  'Reference Document Not Found': function ReferenceDocumentNotFound(_ref) {
    var model = _ref.model,
        value = _ref.value;
    return model + ' \u4E2D\u627E\u4E0D\u5230\u53C3\u7167\u8CC7\u6599 ' + value + '\uFF0C\u672A\u532F\u5165';
  },
  'Header Not Found': function HeaderNotFound(_ref2) {
    var header = _ref2.header;
    return '\u6B04\u4F4D **' + header + '** \u4E0D\u5B58\u5728\u6B64\u8868\u55AE\u4E2D';
  },
  'Option Not Found': function OptionNotFound(_ref3) {
    var value = _ref3.value;
    return '\u627E\u4E0D\u5230\u9078\u9805 **' + value + '**\uFF0C\u672A\u532F\u5165';
  },
  'Unprocessable Entity': function UnprocessableEntity() {
    return '資料檢查錯誤，未匯入';
  },
  'Empty Data': function EmptyData() {
    return '資料為空白，不匯入';
  },
  'Duplicated Data': function DuplicatedData(_ref4) {
    var matchKey = _ref4.matchKey,
        value = _ref4.value;
    return '\u6709\u591A\u7B46\u8CC7\u6599\u7684 **' + matchKey + '** \u503C\u7686\u70BA **' + value + '**\uFF0C\u672A\u532F\u5165';
  }
};
function displayReslut(result, setResult) {
  var importedCounter = 0;
  var errMessage = _ramda2.default.reduce(function (acc, _ref5) {
    var ok = _ref5.ok,
        message = _ref5.message,
        data = _ref5.data;

    if (ok) {
      // WORKAROUND will remove header process result from response
      if (message !== 'Headers Parsed') importedCounter++;
    } else {
      var translater = messageDict[message];
      var counter = data.counter,
          importValues = data.importValues;

      var errorText = translater ? translater(data) : message;
      acc.push({
        ok: ok,
        message: '\u7B2C ' + counter + ' \u5217: ' + errorText + '\uFF0C' + JSON.stringify(importValues)
      });
    }
    return acc;
  }, [], result);
  setResult([].concat(_toConsumableArray(errMessage), [{ ok: true, message: '\u532F\u5165 ' + importedCounter + ' \u7B46\u8CC7\u6599' }]));
}
var upload = function upload(_ref6) {
  var file = _ref6.file,
      modelName = _ref6.modelName,
      setResult = _ref6.setResult;
  return _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
    var type, url;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            type = file.name.split('.').pop();
            url = '/api/stream/data?type=' + type + '&model=' + modelName;

            fetch(url, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/octet-stream'
              },
              body: file
            }).then(function (response) {
              return response.ok ? response : Promise.reject(response);
            }).then(function () {
              var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(response) {
                var json;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        console.debug('upload done');
                        _context.next = 3;
                        return response.json();

                      case 3:
                        json = _context.sent;

                        console.debug('json', json);
                        displayReslut(json.data, setResult);

                      case 6:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, undefined);
              }));

              return function (_x) {
                return _ref8.apply(this, arguments);
              };
            }()).catch(function () {
              var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(error) {
                var json;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        console.debug('upload error', error);
                        _context2.next = 3;
                        return error.json();

                      case 3:
                        json = _context2.sent;

                        console.debug('json', json);
                        displayReslut([{ ok: false, message: json.message }], setResult);

                      case 6:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, undefined);
              }));

              return function (_x2) {
                return _ref9.apply(this, arguments);
              };
            }());

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));
};

var download = function download(_ref10) {
  var modelName = _ref10.modelName;
  return _asyncToGenerator(regeneratorRuntime.mark(function _callee4() {
    var url;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = '/api/stream/data?type=csv&model=' + modelName;

            window.open(url);

          case 2:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));
};

var StreamData = (0, _compose2.default)((0, _withState2.default)('file', 'setFile', null), (0, _withState2.default)('modelName', 'setModelName', null), (0, _withState2.default)('result', 'setResult', []), (0, _withProps2.default)(function (_ref12) {
  var models = _ref12.config.models;
  return {
    modelOptions: Object.keys(models)
  };
}), (0, _withHandlers2.default)({
  onDropAccepted: function onDropAccepted(_ref13) {
    var setFile = _ref13.setFile;
    return function (files) {
      return setFile(files[0]);
    };
  },
  upload: upload,
  download: download
}))(_StreamData2.default);

StreamData.displayName = 'StreamData';

exports.default = StreamData;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/StreamData/index.js
// module id = 1741
// module chunks = 0